module.exports = __webpack_public_path__ + "static/media/schreder_logo.9c99f02e.svg";